module.exports = __webpack_public_path__ + "static/team-3-2d3913707e8be39dca0d27db9d05aebb.jpg";